
import { defineComponent } from "vue";

export default defineComponent({
  name: "merchant-alert",
  components: {},
  setup() {
    const url =
      "https://devcrm.chargebacks.online/images/phpybTFJe20221109125654.png";
    const srcList = [
      "https://devcrm.chargebacks.online/images/phpRU4FmO20221109091334.png",
      "https://devcrm.chargebacks.online/images/phpn7f05x20221109010403.png",
      "https://devcrm.chargebacks.online/images/phpqn4tXv20221109011111.png",
    ];
    return { url, srcList };
  },
});
